'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { initializeApp } from '../../redux/core/thunks.js';
import { useAppDispatch } from '../../redux/hooks.js';
import { ModalWrapper } from '../../redux/wrappers/Modal/index.js';
import { withReduxProvider } from '../../redux/providers.js';
import { UrlBasedModalDispatcher } from './UrlBasedModalDispatcher.js';
import { StepModalWrapper } from '../../redux/wrappers/StepModal/index.js';
export const Modal = (props) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(initializeApp(props));
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(UrlBasedModalDispatcher, {}), _jsx(ModalWrapper, {}), _jsx(StepModalWrapper, {})] }));
};
export const ModalContainer = withReduxProvider(Modal);
//# sourceMappingURL=Modal.js.map